import { strategyToOptions } from "@/common/utils/strategyToOptions";

export const billingFiscalDocumentsStatus = {
  pending: 'Pendente',
  confirmed: 'Confirmada',
  canceled: 'Cancelada',
  invalid: 'Inválida',
  failed: 'Com Falha'
};

export const billingFiscalDocumentsStatusOptions = strategyToOptions(billingFiscalDocumentsStatus);
